import { useContext, useState, useEffect } from "react";
import { Button, Container, Form, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { API } from "../../../../global/global";
import axios from "axios";
import { toast } from "react-toastify";

const PlataformasEdit = () => {
  const { id } = useParams();
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchPlataforma = async () => {
      try {
        const response = await axios.get(`${API}/plataforma/${id}`, {
          headers: {
            Authorization: `Bearer ${authContext.token}`,
          },
        });
        setNombre(response.data.data.nombre);
      } catch (error) {
        console.error("Error fetching plataforma:", error);
        toast.error("Error al cargar la plataforma");
        navigate("/main/catalogos/plataformas");
      } finally {
        setLoading(false);
      }
    };

    fetchPlataforma();
  }, [id, authContext.token, navigate]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    
    if (!nombre.trim()) {
      toast.error("El nombre es requerido");
      return;
    }

    setSaving(true);
    
    try {
      await axios.put(
        `${API}/plataforma/${id}`,
        { nombre: nombre.trim() },
        {
          headers: {
            Authorization: `Bearer ${authContext.token}`,
          },
        }
      );
      
      toast.success("Plataforma actualizada correctamente");
      navigate("/main/catalogos/plataformas");
    } catch (error) {
      console.error("Error updating plataforma:", error);
      toast.error("Error al actualizar la plataforma");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center">
        <Spinner animation="grow" variant="info" />
      </Container>
    );
  }

  return (
    <Container>
      <h1>Editar Plataforma</h1>
      
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre de la Plataforma</Form.Label>
          <Form.Control
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Ingrese el nombre de la plataforma"
            required
          />
        </Form.Group>
        
        <div className="d-flex gap-2">
          <Button
            variant="primary"
            type="submit"
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Actualizando...
              </>
            ) : (
              "Actualizar Plataforma"
            )}
          </Button>
          
          <Button
            variant="secondary"
            onClick={() => navigate("/main/catalogos/plataformas")}
            disabled={saving}
          >
            Cancelar
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default PlataformasEdit;
